import { Typography, TypographyProps } from "@mui/material";
export type PageHaderTitleProps = {
  title?: string | null;
} & Omit<TypographyProps, "variant">;
export const PageHeaderTitle = ({ title, sx, ...others }: PageHaderTitleProps) => {
  return (
    <Typography sx={[{ fontWeight: "700", fontSize: "1.5rem", lineHeight: "1.8125rem" }, ...(Array.isArray(sx) ? sx : [sx])]} variant="h2" {...others}>
      {title}
    </Typography>
  );
};
